var map = {
	"./Activations.vue": [
		"8dca",
		"chunk-161bcd40"
	],
	"./Buyers.vue": [
		"c122",
		"chunk-2d215fe4"
	],
	"./Clients.vue": [
		"58f3",
		"chunk-2d0c9766"
	],
	"./Courses.vue": [
		"1a2f",
		"chunk-f89a26fc"
	],
	"./Dashboard.vue": [
		"7277",
		"chunk-1d251da2"
	],
	"./Dealers.vue": [
		"b253",
		"chunk-2d20efa4"
	],
	"./Distributions.vue": [
		"178c",
		"chunk-749b7b54"
	],
	"./Feedback.vue": [
		"6e7a",
		"chunk-8c789e2e"
	],
	"./GroupDealer.vue": [
		"8a53",
		"chunk-af5a9f78"
	],
	"./History.vue": [
		"e4bb",
		"chunk-2d2259e5"
	],
	"./Login.vue": [
		"a55b"
	],
	"./Moderators.vue": [
		"3710",
		"chunk-2d0ba479"
	],
	"./News.vue": [
		"a2f9",
		"chunk-65cff750"
	],
	"./Notifications.vue": [
		"fda7",
		"chunk-2d23822a"
	],
	"./Orders.vue": [
		"159d",
		"chunk-2d0ab565"
	],
	"./Outlets.vue": [
		"7e44",
		"chunk-2d0e2304"
	],
	"./Pages.vue": [
		"ee3e",
		"chunk-2d230c28"
	],
	"./Products.vue": [
		"e6dc",
		"chunk-c51e7122"
	],
	"./Raffles.vue": [
		"a8a3",
		"chunk-2d20971f"
	],
	"./Serials.vue": [
		"8a6b",
		"chunk-2d0e88cb"
	],
	"./Sliders.vue": [
		"5840",
		"chunk-2d0c9155"
	],
	"./TableList.vue": [
		"6d0d",
		"chunk-2d0daa98"
	],
	"./Tournaments.vue": [
		"c579",
		"chunk-2d216f8a"
	],
	"./UserProfile.vue": [
		"4a39",
		"chunk-2d0cb6c9"
	],
	"./Users.vue": [
		"ed81",
		"chunk-cd6e8ee0"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "1a5d";
module.exports = webpackAsyncContext;